import Image from 'next/image';
import React from 'react';
import { useRouter } from 'next/router';
import { StyledDiv } from 'theme/commonStyled';
import i18n from 'locales/fa.json';
import MuiButton from 'components/Common/MuiButton';
import Icon from 'components/Common/Icon';

const OfflineView: React.FC<{ hasLogo?: boolean }> = ({ hasLogo = true }) => {
  const router = useRouter();
  return (
    <StyledDiv
      color="ash80"
      flexDirection="column"
      isCenter
      minHeight={hasLogo && '100vh'}
    >
      {hasLogo && <Icon name="logo" fontSize={60} color="blue60" mb={20} />}

      <Image src="/images/fallback.svg" width={240} height={176} alt="" />
      <StyledDiv mt={7} mb={5} fontSize={4}>
        {i18n.global.connectionError}
      </StyledDiv>
      <StyledDiv fontSize={2}>{i18n.global.checkConnection}</StyledDiv>
      <MuiButton
        onClick={(): void => router.reload()}
        mt={10}
        variant="whiteText"
        color="blue60"
        startIcon={<Icon name="redo" fontSize={8} ml={5} />}
      >
        {i18n.global.retry}
      </MuiButton>
    </StyledDiv>
  );
};

export default OfflineView;
